import styled from 'styled-components';

const DT = styled.dt`
  font-weight: 400;
  display: inline;
`;

const ScreenReaderDT = styled.dt`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

const DD = styled.dd`
  display: inline;
`;

type Props = {
  esp: string;
  id: string;
  name: string;
};

export const ESPAccount = ({ esp, id, name }: Props) => (
  <dl data-test="sending-domains-esp-account">
    [<DT>ID:</DT>&nbsp;<DD>{id}</DD>] <ScreenReaderDT>Account Type:</ScreenReaderDT>
    <DD>{esp}</DD>
    <div>
      <ScreenReaderDT>Account name:</ScreenReaderDT>
      <DD>{name}</DD>
    </div>
  </dl>
);
